/**
 * Cores das séries dos gráficos.
 *
 * As classes ficam escritas por extenso porque o Tailwind lê o código-fonte
 * para decidir o que gerar: `bg-grafico-${i}` montado em tempo de execução não
 * produziria classe nenhuma. Os tokens em si estão em `index.css`, junto com o
 * restante do tema, e têm variante para o modo escuro.
 */
export interface CorSerie {
  fundo: string;
  preenchimento: string;
  traco: string;
}

const MARCA: CorSerie = {
  fundo: 'bg-grafico-1',
  preenchimento: 'fill-grafico-1',
  traco: 'stroke-grafico-1',
};

export const PALETA: CorSerie[] = [
  MARCA,
  { fundo: 'bg-grafico-2', preenchimento: 'fill-grafico-2', traco: 'stroke-grafico-2' },
  { fundo: 'bg-grafico-3', preenchimento: 'fill-grafico-3', traco: 'stroke-grafico-3' },
  { fundo: 'bg-grafico-4', preenchimento: 'fill-grafico-4', traco: 'stroke-grafico-4' },
  { fundo: 'bg-grafico-5', preenchimento: 'fill-grafico-5', traco: 'stroke-grafico-5' },
  { fundo: 'bg-grafico-6', preenchimento: 'fill-grafico-6', traco: 'stroke-grafico-6' },
];

/** Cor da posição `indice`, dando a volta quando a série é maior que a paleta. */
export function corDaSerie(indice: number): CorSerie {
  return PALETA[indice % PALETA.length] ?? MARCA;
}
